import seal from "../../../assets/Services_img/seal.webp";

export const sealGasketReplacementService = {
  hero: {
    title: "Seal, Gasket & O-Ring ",
    description:
      "Maintaining leak-tight integrity and pressure stability for critical glovebox operations.",
      title2:"Replacement",
      imgUrl:seal
  },

  productsDetails: {
    imgList: [
      seal
    ],

    productName: "Seal, Gasket & O-Ring Replacement",

    description:
      "This service focuses on restoring and maintaining the airtight integrity of glovebox systems by replacing worn or degraded seals, gaskets, and O-rings. Our engineers replace antechamber seals, door gaskets, feedthrough O-rings, and other critical sealing components to ensure stable pressure control and contamination-free operation.",

    keyFeatures: [
      "Antechamber seal replacement",
      "Door and panel gasket renewal",
      "Feedthrough and port O-ring replacement",
      "Leak detection and pressure integrity testing",
      "Compatibility with OEM and custom glovebox systems",
    ],

    download: {
      title: "Download Service Overview PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Service Description",

    briefDescirption:
      "Sealing components naturally degrade over time, leading to leaks, pressure instability, and contamination risks. This service restores glovebox integrity, improves operational reliability, and supports long-term system performance in sensitive laboratory and industrial environments.",
  },
};
